/* ============================================================
   BBF PRODUCT PAGE — Gallery, Variant picker, ATC
   ============================================================ */
(function () {
  'use strict';

  function initBBFProduct(sectionId) {
    var data         = (window.BBFProductData && window.BBFProductData[sectionId]) || {};
    var productFormId = data.formId || ('bbf-product-form-' + sectionId);

    var galleryMain  = document.getElementById('bbf-gallery-main-' + sectionId);
    var dotsWrap     = document.getElementById('bbf-dots-' + sectionId);
    var slides       = galleryMain ? Array.from(galleryMain.querySelectorAll('.bbf-pdp__slide')) : [];
    var thumbs       = Array.from(document.querySelectorAll('#bbf-gallery-main-' + sectionId + ' ~ .bbf-pdp__thumbs .bbf-pdp__thumb'));
    var dots         = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.bbf-pdp__dot')) : [];
    var pricesEl     = document.getElementById('bbf-prices-' + sectionId);
    var variantInput = document.getElementById('bbf-variant-id-' + sectionId);
    var atcBtn        = document.getElementById('bbf-atc-' + sectionId);
    var atcText       = atcBtn ? atcBtn.querySelector('.bbf-pdp__atc-text') : null;
    var atcBar        = document.getElementById('bbf-atc-bar-' + sectionId);
    var stickyBar     = document.getElementById('bbf-sticky-bar-' + sectionId);
    var stickyAtcBtn  = document.getElementById('bbf-sticky-atc-' + sectionId);
    var stickyAtcText = stickyAtcBtn ? stickyAtcBtn.querySelector('.bbf-pdp__atc-text') : null;
    var stickyPriceEl = document.getElementById('bbf-sticky-price-' + sectionId);
    var variantDataEl = document.getElementById('bbf-variant-data-' + sectionId);

    if (!galleryMain) return;

    var variants = [];
    if (variantDataEl) {
      try { variants = JSON.parse(variantDataEl.textContent); } catch (e) {}
    }

    /* ---------------------------------------------------
       GALLERY — Desktop thumbnail clicks
    --------------------------------------------------- */
    function showSlide(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i)   { d.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(parseInt(thumb.dataset.index, 10));
      });
    });

    /* ---------------------------------------------------
       GALLERY — Desktop prev/next arrows
    --------------------------------------------------- */
    var galleryArrows = galleryMain ? Array.from(galleryMain.querySelectorAll('.bbf-pdp__arrow')) : [];
    if (galleryArrows.length && slides.length > 1) {
      galleryArrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
          if (current === -1) current = 0;
          var dir = arrow.dataset.dir === 'next' ? 1 : -1;
          var next = (current + dir + slides.length) % slides.length;
          showSlide(next);
        });
      });
    }

    /* ---------------------------------------------------
       GALLERY — Mobile scroll → update dots
    --------------------------------------------------- */
    if (galleryMain && dots.length) {
      galleryMain.addEventListener('scroll', function () {
        var idx = Math.round(galleryMain.scrollLeft / galleryMain.offsetWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    /* ---------------------------------------------------
       VARIANT PICKER
    --------------------------------------------------- */
    function getSelectedOptions() {
      var opts = [];
      var section = document.querySelector('[data-section="' + sectionId + '"]');
      if (!section) return opts;
      section.querySelectorAll('.bbf-pdp__option').forEach(function (optEl) {
        var checked = optEl.querySelector('.bbf-pdp__pill-input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(selectedOpts) {
      return variants.find(function (v) {
        return v.options.length === selectedOpts.length &&
          v.options.every(function (o, i) { return o === selectedOpts[i]; });
      }) || null;
    }

    function formatMoney(cents) {
      /* Use the store's no-decimal format when available */
      if (window.Shopify && Shopify.formatMoney) {
        var fmt = Shopify.money_without_trailing_zeros_format || Shopify.money_format || 'Rs. {{amount}}';
        return Shopify.formatMoney(cents, fmt);
      }
      /* Fallback: strip .00 manually */
      var amount = cents / 100;
      var rounded = Math.round(amount);
      return 'Rs. ' + rounded.toLocaleString('en-IN');
    }

    function updatePriceHTML(variant) {
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if (!pricesEl) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        pricesEl.innerHTML =
          '<span class="bbf-pdp__price bbf-pdp__price--sale">' + formatMoney(variant.price) + '</span>' +
          '<s class="bbf-pdp__price bbf-pdp__price--compare">' + formatMoney(variant.compare_at_price) + '</s>';
      } else {
        pricesEl.innerHTML = '<span class="bbf-pdp__price">' + formatMoney(variant.price) + '</span>';
      }
    }

    function updateATCButton(variant) {
      var available = variant && variant.available;
      /* Inline button */
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.classList.toggle('is-soldout', !available);
        if (atcText) atcText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      }
      /* Sticky button */
      if (stickyAtcBtn) {
        stickyAtcBtn.disabled = !available;
        stickyAtcBtn.classList.toggle('is-soldout', !available);
        if (stickyAtcText) stickyAtcText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      }
    }

    function updateVariantImage(variant) {
      if (!variant || !variant.featured_media) return;
      var targetSlide = galleryMain.querySelector('.bbf-pdp__slide[data-media-id="' + variant.featured_media.id + '"]');
      if (targetSlide) {
        var idx = parseInt(targetSlide.dataset.index, 10);
        showSlide(idx);
        /* On mobile, scroll to the slide */
        if (window.innerWidth < 750) {
          galleryMain.scrollTo({ left: idx * galleryMain.offsetWidth, behavior: 'smooth' });
        }
      }
    }

    function onOptionChange() {
      var selectedOpts = getSelectedOptions();
      var variant = findVariant(selectedOpts);
      if (!variant) return;

      /* Update hidden form input + URL */
      if (variantInput) variantInput.value = variant.id;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      updatePriceHTML(variant);
      updateATCButton(variant);
      updateVariantImage(variant);
    }

    var section = document.querySelector('[data-section="' + sectionId + '"]');
    if (section) {
      section.querySelectorAll('.bbf-pdp__pill-input').forEach(function (input) {
        input.addEventListener('change', onOptionChange);
      });
    }

    /* ---------------------------------------------------
       QUANTITY STEPPER
    --------------------------------------------------- */
    if (section) {
      section.querySelectorAll('.bbf-pdp__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qtyInput = btn.closest('.bbf-pdp__qty').querySelector('.bbf-pdp__qty-input');
          if (!qtyInput) return;
          var val = parseInt(qtyInput.value, 10) || 1;
          if (btn.dataset.action === 'plus') {
            qtyInput.value = Math.min(val + 1, parseInt(qtyInput.max, 10) || 99);
          } else {
            qtyInput.value = Math.max(val - 1, parseInt(qtyInput.min, 10) || 1);
          }
        });
      });
    }

    /* ---------------------------------------------------
       ADD TO CART — AJAX submit
       Button lives outside <form> and references it via form="..."
       We intercept clicks on the button directly.
    --------------------------------------------------- */
    /* form variable kept for potential future use */
    var form = document.getElementById(productFormId); // eslint-disable-line no-unused-vars

    /* Intercept button click (not form submit, since button is outside form) */
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();

        var id = variantInput ? parseInt(variantInput.value, 10) : null;
        if (!id) return;

        var qtyInput = section ? section.querySelector('.bbf-pdp__qty-input') : null;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

        /* Loading state */
        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'ADDING…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          /* Success */
          atcBtn.classList.remove('is-loading');
          if (atcText) atcText.textContent = 'ADDED ✓';

          /* Fire event — opens BBF cart drawer + refreshes it */
          document.dispatchEvent(new CustomEvent('bbf:cart:updated'));

          /* Reset after 1.8s */
          setTimeout(function () {
            atcBtn.disabled = false;
            if (atcText) atcText.textContent = 'ADD TO CART';
          }, 1800);
        })
        .catch(function (err) {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
          if (atcText) atcText.textContent = 'TRY AGAIN';
          setTimeout(function () {
            if (atcText) atcText.textContent = 'ADD TO CART';
          }, 2000);
          console.warn('BBF ATC error:', err.message);
        });
      });
    }

    /* ---------------------------------------------------
       STICKY ATC BAR — show when inline bar scrolls out of view
    --------------------------------------------------- */
    function doATC(btn, textEl) {
      var id = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!id) return;
      var qtyInput = section ? section.querySelector('.bbf-pdp__qty-input') : null;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

      btn.classList.add('is-loading');
      btn.disabled = true;
      if (textEl) textEl.textContent = 'ADDING…';

      /* Safety reset: the external cart app can intercept/swallow the
         /cart/add.js request so our promise never settles — never leave the
         button stuck on "ADDING…". */
      var settled = false;
      var safety = setTimeout(function () {
        if (settled) return;
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (textEl) textEl.textContent = 'ADD TO CART';
        document.dispatchEvent(new CustomEvent('bbf:cart:updated'));
      }, 2200);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        settled = true; clearTimeout(safety);
        btn.classList.remove('is-loading');
        if (textEl) textEl.textContent = 'ADDED ✓';
        document.dispatchEvent(new CustomEvent('bbf:cart:updated'));
        setTimeout(function () {
          btn.disabled = false;
          if (textEl) textEl.textContent = 'ADD TO CART';
        }, 1800);
      })
      .catch(function (err) {
        settled = true; clearTimeout(safety);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (textEl) textEl.textContent = 'TRY AGAIN';
        setTimeout(function () { if (textEl) textEl.textContent = 'ADD TO CART'; }, 2000);
        console.warn('BBF ATC error:', err.message);
      });
    }

    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        doATC(stickyAtcBtn, stickyAtcText);
      });
    }

    if (atcBar && stickyBar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
          /* Lift floating widgets (e.g. WhatsApp) above the bar while it shows */
          document.documentElement.classList.toggle('bbf-atc-bar-visible', show);
        });
      }, { threshold: 0 });
      io.observe(atcBar);
    }

    /* ---------------------------------------------------
       JUDGE.ME — reinit badges
    --------------------------------------------------- */
    if (window.jdgm) {
      if (typeof jdgm.loadBadges === 'function') jdgm.loadBadges();
    } else {
      document.addEventListener('jdgm:all:load', function () {
        if (typeof jdgm.loadBadges === 'function') jdgm.loadBadges();
      }, { once: true });
    }
  }

  /* ---------------------------------------------------
     Bootstrap — run on DOMContentLoaded
  --------------------------------------------------- */
  function boot() {
    if (window.BBFProductData) {
      Object.keys(window.BBFProductData).forEach(function (id) {
        initBBFProduct(id);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Support Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    if (window.BBFProductData && window.BBFProductData[e.detail.sectionId]) {
      initBBFProduct(e.detail.sectionId);
    }
  });

})();
